export const CUSTOM_RULES_V1 = 'custom-daily-rules-v1';
export const CUSTOM_RULES_V2 = 'custom-daily-rules-v2';
export const CUSTOM_RULES_V3 = 'custom-daily-rules-v3';
export const CUSTOM_SCHEMA_V1 = '3.0';
export const CUSTOM_SCHEMA_V2 = '3.1';
export const CUSTOM_SCHEMA_V3 = '3.2';

export const TIME_EXIT_COUNTING_POLICY = 'exchange_sessions_inclusive_from_entry_v1';
export const TIME_EXIT_TRIGGER_BASIS = 'completed_exchange_session';
export const TIME_EXIT_EXECUTION_TIMING = 'next_eligible_open';

export const isEditableCustomEvaluator = (evaluator) => (
  evaluator === CUSTOM_RULES_V1 || evaluator === CUSTOM_RULES_V2 || evaluator === CUSTOM_RULES_V3
);

export const maximumHoldingState = (configuration) => {
  const policy = configuration?.exit_policy?.time_exit;
  return {
    enabled: policy?.enabled === true,
    sessions: policy?.enabled === true ? policy.maximum_holding_sessions : '',
  };
};

export const validateMaximumHolding = ({ enabled, sessions }) => {
  if (!enabled) return '';
  const text = String(sessions ?? '').trim();
  if (!/^\d+$/.test(text)) {
    return 'Enter a whole number of completed market sessions from 1 to 250.';
  }
  const value = Number(text);
  if (!Number.isSafeInteger(value) || value < 1 || value > 250) {
    return 'Maximum holding sessions must be between 1 and 250.';
  }
  return '';
};

const enabledPolicy = (sessions) => ({
  enabled: true,
  maximum_holding_sessions: sessions,
  counting_policy: TIME_EXIT_COUNTING_POLICY,
  trigger_basis: TIME_EXIT_TRIGGER_BASIS,
  execution_timing: TIME_EXIT_EXECUTION_TIMING,
});

export const setMaximumHoldingEnabled = (
  configuration, { enabled, parentEvaluator, defaultSessions = 20 },
) => {
  const next = structuredClone(configuration);
  if (parentEvaluator === CUSTOM_RULES_V3) {
    next.evaluator_version = CUSTOM_RULES_V3;
    next.strategy_schema_version = CUSTOM_SCHEMA_V3;
    next.exit_policy.time_exit = enabled
      ? enabledPolicy(defaultSessions)
      : { enabled: false };
    return next;
  }
  if (enabled) {
    next.evaluator_version = CUSTOM_RULES_V2;
    next.strategy_schema_version = CUSTOM_SCHEMA_V2;
    const current = maximumHoldingState(next).sessions;
    next.exit_policy.time_exit = enabledPolicy(
      Number.isInteger(current) ? current : defaultSessions,
    );
  } else if (parentEvaluator === CUSTOM_RULES_V1) {
    next.evaluator_version = CUSTOM_RULES_V1;
    next.strategy_schema_version = CUSTOM_SCHEMA_V1;
    next.exit_policy.time_exit = null;
  } else {
    next.evaluator_version = CUSTOM_RULES_V2;
    next.strategy_schema_version = CUSTOM_SCHEMA_V2;
    next.exit_policy.time_exit = { enabled: false };
  }
  return next;
};

export const setMaximumHoldingSessions = (configuration, rawValue) => {
  const next = structuredClone(configuration);
  const text = String(rawValue ?? '').trim();
  next.exit_policy.time_exit = enabledPolicy(/^\d+$/.test(text) ? Number(text) : text);
  return next;
};

export const maximumHoldingDisplay = (configuration) => {
  const state = maximumHoldingState(configuration);
  return state.enabled ? `${state.sessions} completed market sessions` : 'None';
};

export const maximumHoldingReview = (configuration) => {
  const state = maximumHoldingState(configuration);
  return {
    display: maximumHoldingDisplay(configuration),
    enabled: state.enabled,
    whatHappens: state.enabled
      ? `If the position is still open after session ${state.sessions}, Pinngro can propose closing it at the next eligible market open.`
      : 'This strategy has no maximum-holding exit.',
  };
};
